import Vue, { CreateElement } from 'src/vue'
import { Component } from 'vue-property-decorator'
import { Button } from 'src/elements/button/button'
import { Tabs, Tab } from 'src/components/tabs/tabs'
import { WorkoutType } from '@src/data/workout-data'
import Club from '@src/data/club'

import './content.sass'
import { isMobileBrowser } from '@src/util/functions'
import SessionManager from '@src/lib/session_manager'

enum ContentType {
  EXERCISES = 'exercises',
  WORKOUTS = 'workouts',
  TRAINING_PLAN = 'trainingplan',
  CLASSES = 'classes'
}

@Component({
  computed: {
    club () {
      return this.$store.state.club
    }
  }
})
export class Content extends Vue {

  private club: Club

  // private showCreateTooltip: boolean = false

  constructor () {
    super()
  }

  // showCreateWorkoutOptions () {
  //   this.showCreateTooltip = !this.showCreateTooltip
  // }

  goToCreateWorkout () {
    this.$store.dispatch('removeNewWorkout')
    this.$store.dispatch('setWorkoutType', WorkoutType.CUSTOM)
    this.$router.push('/trainers/workout')
  }

  goToTrainingPlanBuilder () {
    this.$store.dispatch('removeNewTrainingPlan')
    this.$router.push('/trainers/trainingPlan')
  }

  selectTab (type: ContentType) {
    this.$router.push(`/trainers/platform/content/${type}`)
  }

  isTabSelected (type: ContentType) {
    return this.$route.path.indexOf(type) >= 0
  }

  render (h: CreateElement) {
    return <div class='contentWrapper'>
      <Tabs>
        <Tab label={this.$t('PAGE.CONTENT.EXERCISES.TAB_NAME')} selected={this.isTabSelected(ContentType.EXERCISES)}
             selectTab={() => this.selectTab(ContentType.EXERCISES)} />
        <Tab label={this.$t('PAGE.CONTENT.WORKOUTS.TAB_NAME')} selected={this.isTabSelected(ContentType.WORKOUTS)}
             selectTab={() => this.selectTab(ContentType.WORKOUTS)} />
        <Tab label={this.$t('PAGE.CONTENT.TRAINING_PLAN.TAB_NAME')} selected={this.isTabSelected(ContentType.TRAINING_PLAN)}
             selectTab={() => this.selectTab(ContentType.TRAINING_PLAN)} />
        {this.club.showClasses && <Tab label={this.$t('PAGE.CONTENT.CLASSES.TAB_NAME')} selected={this.isTabSelected(ContentType.CLASSES)}
             selectTab={() => this.selectTab(ContentType.CLASSES)} />}
        {this.isTabSelected(ContentType.WORKOUTS) && !SessionManager.Instance.isAssistant() ?
          isMobileBrowser() ? <Button type='elevated' class='create-btn' align='right' icon={'util/add'} click={this.goToCreateWorkout} /> :
              <Button type='elevated' class='create-btn' align='right' label={this.$t('NEW')} click={this.goToCreateWorkout} />
            : null}
        {/*Hide home workouts*/}
        {/*{this.showCreateTooltip ? <CreateWorkoutTooltip closeTooltip={this.showCreateWorkoutOptions} /> : null}*/}

        {this.isTabSelected(ContentType.TRAINING_PLAN) && !SessionManager.Instance.isAssistant() ? isMobileBrowser() ? <Button type='elevated' class='create-btn' align='right' icon={'util/add'} click={this.goToTrainingPlanBuilder} /> :
                <Button type='elevated' class='create-btn' align='right' label={this.$t('NEW')} click={this.goToTrainingPlanBuilder} />
            : null}
      </Tabs>

      <div class='component-tabs-body scroll-content' id='component-tabs-body'>
        <router-view />
      </div>
    </div>
  }

  beforeMount () {
    // remove the member set to for the active workout/training plan (when entering the trainings screen, the member is persisted to be shown in the builder page)
    this.$store.dispatch('setMemberForActiveTraining', null)
    this.$store.dispatch('setSelectedMember', null)
  }
}
